import PropTypes from "prop-types";
import React, { Component } from "react";
import { Header } from "semantic-ui-react";

/**
 * Overrides the default TitleField to set as default:
 * - add `dividing` prop
 */
export class RJSFTitleField extends Component {
  render() {
    const { options, title } = this.props;
    const { semantic = {} } = options;

    // Filter out problematic props
    const { wrapItem, ...cleanSemantic } = semantic;
    const safeProps = {
      ...cleanSemantic,
      inverted: semantic.inverted ? "true" : undefined,
    };

    return title ? (
      <Header dividing as="h4" {...safeProps}>
        {title}
      </Header>
    ) : null;
  }
}

RJSFTitleField.propTypes = {
  options: PropTypes.object,
  title: PropTypes.string,
};

RJSFTitleField.defaultProps = {
  options: {
    semantic: {
      inverted: false,
      dividing: true,
    },
  },
  title: null,
};
